import {getImageUrl, onError, message, errorHandler, logout, loader, getAppliedFilters, routeErrorHandler} from '@/libs/helper'
import {cloneDeep, isEmpty, find} from 'lodash'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import {getOrganisationsTeam, deleteOrganisationTeam, getTeamPermissions} from '@/libs/api/api'
import OrgFilter from '@/components/pages/InformationPortal/Organisation/OrgFilter/OrgFilter.vue'
import InfiniteLoading from 'vue-infinite-loading';
import {mapGetters} from 'vuex'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
import permissions from '@/libs/constant/permissions'

export default {
    name: 'OrgTeams',
    mixins: [OrganisationRolesErrorHandlerMixin],
    components: {
      OrgFilter,
      InfiniteLoading
    },
    props: {
      updateCount: {
          type: Function,
          default: () => {}
      }
    },
    beforeMount() {
      // set teams 
      this.setTeams()
      this.fetchTeamPermissions()
    },

    beforeDestroy() {
      // clear the filter list
      this.$store.dispatch('setOganisationFilters', {})
    },
    computed: {
      ...mapGetters({
        organisationRoles: 'getOrganisationRoles', hasPermission: 'hasPermission'
      })
    },
    data() {
        return {
            isEmpty,
            onError,
            getImageUrl,
            columns: ['checkbox', 'name', 'settings'],
            teams: [],
            teamResult: {},
            tableData: [],
            isRemoveTeam: false,
            selectedTableFilters: {},
            teamToBeRemoved: {},
            isAssetToTeam: false,
            rightsTransferToTeam: {},
            teamsPermissions: [],
            currentPage: 1,
            skip: 0,
            limit: 30,
            teamSkip: 0,
            teamLimit: 30,
            teamsList: [],
            loadMore: true,
            sort: 'name',
            order: 'desc',
            tableSettings: {
                headings: {
                  checkbox: 'checkbox',
                  name: 'Team Name',
                  settings: ''
                },
                pagination: { show: false},
                perPage: 30,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
              },
            permissions: permissions
        }
    },
    methods: {

      /**
       * route To add teams page
       */
      routeToAddTeams () {
        this.$router.push({name: 'add-team'}).catch(() => {})
      },

      /**
       * to set the teams organisations teams 
       */
      async setTeams () {
        if(!this.hasPermission(permissions.getTeamList)) return;
        // params for api
        let params = {
          skip: this.skip,
          limit: this.limit,
          sort: this.sort,
          order: this.order
        }
        // body for api
        let body = await getAppliedFilters(this.selectedTableFilters)
        let isUpdateCount = isEmpty(body)
        body.organisation = this.$route.params.id
        // api call
        getOrganisationsTeam(body, params).then(response => {
            this.teamResult = response || {}
            this.teams = response.items || []
            // to update the count in top header
            if (isUpdateCount) this.updateCount(constants.ORGANISATIONS.TEAM, response.total_count)
        }).catch(error => {
          message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
          // error handler for permissions
          this.rolesErrorHandler(error)
        })
      },

      /**
       * handle Command
       * @param {*} event 
       * @param {*} data 
       */
      handleCommand (event, data) {
        switch (event) {
          case 'EDIT':
            this.$store.dispatch('setTeam', data)
            this.$router.push({name: pageRoute.editTeam, params: {tid: data._id}})
          break
          case 'DELETE': 
          // to set the team to be removed
            this.teamToBeRemoved = data
            // to fetch teams list to show in popup
            this.getTeamListForPopup()
            // to show popup
            this.isRemoveTeam = true
          break
        }
      },

      /**
       * remove team
       */
      removeTeamHandler (data) {
        loader(this, true)
        // body for api
        let body = {}
        if (this.isAssetToTeam) body.team = this.rightsTransferToTeam._id
        // api call
          deleteOrganisationTeam(data._id, body).then((response) => {
            // to refetch the list
            this.setTeams()
            message(this, constants.messageType.SUCCESS, (response.message || 'deleted_successfully'))
            loader(this, false)
          }).catch(error => {
            message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
            // error handler for permissions
            this.rolesErrorHandler(error)
            loader(this, false)
          }) 
          // to close the popup
          this.closeRemovePopup()
      },

      /**
       * to change the pages 
       * @param {*} currentPage 
       */
      changePage (currentPage) {
          this.currentPage = currentPage
          // setting the skip as per the current page
          this.skip = (currentPage - 1) * this.limit
          // call for fetching the articles
          this.setTeams()
      },

      /**
       * rouute to internal page of teams member
       * @param {*} team team._id
       */
      routeToInternalMembersPage (team) {
        if (this.showSettingsDropdown(team)) {
          this.$store.dispatch('setTeam', team)
          this.$router.push({name: 'teams-members', params: {tid: team._id}})
        } 
      },

      /**
       * to change sort 
       */
      changeOrder () {
        // change sort
        this.order = this.order === 'desc' ? 'asc' : 'desc'
        // set skip to zero
        this.skip = 0
        // fetch new teams
        this.setTeams()
      },

      /**
       * 
       * @param {*} filters 
       */
      setTableFilters (filters) {
          this.selectedTableFilters = cloneDeep(filters)
          this.$store.dispatch('setOganisationFilters', filters)
          this.changePage(1)
      },

      /**
       * close remove popup
       */
      closeRemovePopup () {
        this.isRemoveTeam = false
        this.teamToBeRemoved = {}
        this.rightsTransferToTeam = {}
        this.teamSkip = 0
        this.teamsList = []
        this.loadMore = true
        this.isAssetToTeam = false
      },

      /**
       * team list for the remove popup
       */
      getTeamListForPopup (isLoadMore) {
        if(!this.hasPermission(permissions.getTeamList)) return;
        this.isFetching = true
        // params for api
        let params = {
          skip: this.teamSkip,
          limit: this.teamLimit
        }
        // body for api
        let body = {
          organisation: this.$route.params.id
        }
        getOrganisationsTeam(body, params).then(response => {
          let items = response.items || []
          // filter out the selected team to be removed
          items = items.filter(item => item._id !== this.teamToBeRemoved._id)
          // if load more then concat list with existing one
          if (isLoadMore) this.teamsList = this.teamsList.concat(items || [])
          // else intialise the list
          else this.teamsList = items || []
          if (response.item_count < this.teamLimit) {
            this.loadMore = false
          }
          this.teamSkip += this.teamLimit
          this.isFetching = false
        }).catch(error => {
          // error msg
          message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
          // error handler for permissions
          this.rolesErrorHandler(error)
            this.loadMore = false
            this.isFetching = false
        })
      },

      /**
       * infinite loading handler
       */
      handleInfiniteLoading () {
        if (!this.isFetching && this.loadMore) this.getTeamListForPopup(true)
      },

      /**
       * route to users page
       * @param {*} user 
       */
      routeToUsersOverviewPage (user) {
        this.$router.push({name: pageRoute.usersOverview, params: {id: user._id}})
      },
      /**
       * fetchTeamPermissions
       */
      fetchTeamPermissions () {
        getTeamPermissions().then(response => {
          this.teamsPermissions = response
        })
      },

      /**
       * settings dropdown show/hide
       * @param {*} team 
       */
      showSettingsDropdown (team) {
        let isShow = false
        let teamRole = find(this.teamsPermissions, {role: team && team.role && team.role === 'Lead' ? 'OWNER' : team.role})
        if (this.organisationRoles && this.organisationRoles.permissions && this.organisationRoles.permissions.includes(this.$getConst('TEAM_SETTINGS_DROPDOWN'))) isShow = true
        if (!isEmpty(teamRole) && teamRole.permissions && teamRole.permissions.includes(this.$getConst('TEAM_SETTINGS_DROPDOWN'))) isShow = true
        return isShow
      }
    }
}